/* global filter_obj */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {

    const sections = document.querySelectorAll('.partner-grid-section');
    sections.forEach(section => {
        const swiperEl = section.querySelector('.pgs-popup-content-list');
        if (!swiperEl) {return;}

        initPartnerSwiper(section);

        // Click on grid items
        section.addEventListener('click', function(e) {

            const card = e.target.closest('.pgs-card');
            if (!card) {return;}

            document.body.classList.add('scroll-fixed');

            const targetId = card.getAttribute('data-href');

            const swiper = section.querySelector('.pgs-popup-content-list')?.swiper;
            goToSlideById(swiper, targetId);

            const wrap = section.querySelector('.pgs-wrap');
            if (wrap) {wrap.classList.add('is-visible');}

            setTimeout(() => {
                const popup = section.querySelector('.pgs-popup');
                if (popup) {popup.classList.add('is-visible');}
            }, 150);
        });

        // Close popup
        document.addEventListener('click', function(e) {
            if (
                e.target.closest('.pgs-popup-close') ||
                e.target.closest('.pgs-popup-overlay')
            ) {
                document.body.classList.remove('scroll-fixed');

                section.querySelector('.pgs-wrap') ?.classList.remove('is-visible');
                section.querySelector('.pgs-popup') ?.classList.remove('is-visible');
            }
        });
    });

    // 🔥 Match data-href to data-id (LOOP SAFE)
    function goToSlideById(swiper, targetId) {
        const slides = swiper.slides;

        for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const content = slide;

            if (content && content.getAttribute('data-id') === targetId) {
                swiper.slideTo(i);
                break;
            }
        }
    }

});

(function($) {
    $(document).ready(function() {
        // Filter form submission
        $('.partner-grid-section').each(function() {
            const section = $(this);
            const form = section.find('form.pgs-filter-form');

            // Search input change / keydown
            form.find('.search-text').on('keypress', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();

                    section.find('#pager').val(1);

                    const posts_per_page = parseInt(section.find('#posts_per_page').val(), 10) || 8;

                    partnerGrid(section, 1, posts_per_page);
                }
            });
            form.find('.search-btn').on('click', function(e) {
                e.preventDefault();

                section.find('#pager').val(1);

                const posts_per_page = parseInt(section.find('#posts_per_page').val(), 10) || 8;

                partnerGrid(section, 1, posts_per_page);
            });

            if ($('.pgs-cat-filter-dropdown').length > 0) {
                $('.pgs-cat-filter-dropdown .pgs-filter-title').click(function(e) {
                    e.preventDefault();

                    const currentDropdown = $(this).closest('.pgs-cat-filter-dropdown');
                    const currentMenu = $(this).next('.pgs-filter-menu');

                    // Close all other dropdowns
                    $('.pgs-cat-filter-dropdown').not(currentDropdown).removeClass('is-active').find('.pgs-filter-menu').slideUp();

                    // Toggle current dropdown
                    currentDropdown.toggleClass('is-active');
                    currentMenu.stop(true, true).slideToggle();
                });
            }

            // ✅ Click outside → close all
            $(document).click(function(e) {
                if (!$(e.target).closest('.pgs-cat-filter-dropdown').length) {
                    $('.pgs-cat-filter-dropdown').removeClass('is-active').find('.pgs-filter-menu').slideUp();
                }
            });

            form.find('.load-more-partner').on('click', function() {

                section.find('.no-more-result').hide();
                section.find('.filter-load-more').show();
                section.find('.load-more-partner').hide();

                const posts_per_page = parseInt(section.find('#posts_per_page').val(), 10) || 8;
                let input_page_num = parseInt(section.find('#pager').val(), 10) || 1;
                input_page_num++;
                section.find('#pager').val(input_page_num);

                // const capability = $('input[name="capability"]:checked').val() || 'all';

                partnerGrid(section, input_page_num, posts_per_page);
            });

            // Filter change
            section.on('change', '.pgs-radio', function() {
                const selectedVal = $(this).val();

                // 🔁 Sync ALL radios (desktop + mobile)
                section.find('.pgs-radio').each(function() {
                    if ($(this).val() === selectedVal) {
                        this.checked = true;
                    } else {
                        this.checked = false;
                    }
                });

                // 🔄 Reset grid
                section.find('.pgs-row').empty();
                section.find('#pager').val(1);

                const posts_per_page = parseInt(section.find('#posts_per_page').val(), 10) || 8;

                partnerGrid(section, 1, posts_per_page);
            });
            // Operating Units function
        });

        function partnerGrid(section, input_page_num, posts_per_page) {
            $.ajax({
                url: filter_obj.ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'fetch_partner_list',
                    paged: input_page_num,
                    posts_per_page: posts_per_page,
                    search_text: section.find('.search-text').val(),
                    capability: section.find('input[name="capability"]:checked').val() || '',
                },
                beforeSend: function() {
                    section.find('.filter-load-more').show();
                    section.find('.load-more-partner').hide();
                    section.find('.no-more-result').hide();
                },
                success: function(res) {
                    const html = res.html || '';
                    const popup_html = res.popup_html || '';
                    const next = res.next || 0;

                    section.find('.filter-load-more').hide();

                    if (input_page_num === 1) {
                        section.find('.pgs-row').html(html);
                        section.find('.swiper-wrapper').html(popup_html);
                    } else {
                        section.find('.pgs-row').append(html);
                        section.find('.swiper-wrapper').append(popup_html);
                    }

                    if (!html.trim()) {
                        section.find('.no-more-result').show();
                        section.find('.load-more-partner').hide();
                        return;
                    }

                    section.find('.no-more-result').hide();
                    section.find('.load-more-partner').toggle(next === 1);

                    setTimeout(() => {
                        const section = document.querySelector('.partner-grid-section');
                        initPartnerSwiper(section);
                    }, 0);
                },
                error: function(err) {
                    section.find('.no-more-result').show();
                    section.find('.filter-load-more').hide();
                },
            });
        }
    });
})(jQuery);

function initPartnerSwiper(section) {
    const swiperEl = section.querySelector('.pgs-popup-content-list');
    if (!swiperEl) {return null;}

    // destroy old instance safely
    if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
    }

    const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
            prevEl: section.querySelector('.pgs-button-prev'),
            nextEl: section.querySelector('.pgs-button-next'),
        },
        pagination: {
            el: section.querySelector('.pgs-pagination'),
            clickable: true,
            // dynamicBullets: true,
        },
    });

    // 🔥 CRITICAL: sync both references
    swiperEl.swiper = swiper;
    return swiper;
}